export const MAX_GENRE_TAGS_NUMBER = 5;
